import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeRoutingModule} from './home-routing.module';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OwlModule} from 'ngx-owl-carousel';

import {IntroThreeComponent} from './intro-three/intro-three.component';
import {AboutComponent} from './about/about.component';
import {FeatureComponent} from './feature/feature.component';
import {ScreenshotComponent} from './screenshot/screenshot.component';
import {BlogComponent} from './blog/blog.component';
import {NewsletterComponent} from './newsletter/newsletter.component';
import {OrderComponent} from './order/order.component';
import {HomeFourComponent} from './versions/home-four/home-four.component';
import {VideoComponent} from './video/video.component';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    OwlModule
  ],
  declarations: [
    HomeFourComponent,
    IntroThreeComponent,
    AboutComponent,
    FeatureComponent,
    ScreenshotComponent,
    BlogComponent,
    NewsletterComponent,
    OrderComponent,
    VideoComponent
  ],
  providers: []
})
export class HomeModule {
}
